import { render, staticRenderFns } from "./ZoneGroup.vue?vue&type=template&id=ed2e2f7e"
import script from "./ZoneGroup.vue?vue&type=script&lang=js"
export * from "./ZoneGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports